// @flow
import {logExperiment} from '@homeaway/abacus-client-utils';

import type {State as AbacusState} from '../reducers/abacus';

export function logExperiments(abacus: AbacusState, experiments: string[]) {
    experiments.forEach((key) => {
        const experiment = abacus[key];
        if (experiment) {
            logExperiment(experiment);
        }
    });
}
